import { render } from "./RacesTable.vue?vue&type=template&id=3afa183c&scoped=true&ts=true"
import script from "./RacesTable.vue?vue&type=script&lang=ts"
export * from "./RacesTable.vue?vue&type=script&lang=ts"

import "./RacesTable.vue?vue&type=style&index=0&id=3afa183c&lang=scss&scoped=true"

import exportComponent from "/workspace/hound-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3afa183c"]])

export default __exports__